import { render, staticRenderFns } from "./SaleReport.vue?vue&type=template&id=38e33e32&scoped=true"
import script from "./SaleReport.vue?vue&type=script&lang=js"
export * from "./SaleReport.vue?vue&type=script&lang=js"
import style0 from "./SaleReport.vue?vue&type=style&index=0&id=38e33e32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e33e32",
  null
  
)

export default component.exports